import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@cotyorg/ccx-molecules/IconButton';

export const getPlayPauseIcon = ({
  playing,
  pauseIconSrc,
  playIconSrc,
}) => (playing ? pauseIconSrc : playIconSrc);

// istanbul ignore next
const PlayPauseControl = ({
  id,
  title,
  playing,
  setTogglePlayPause,
  pauseIconSrc,
  playIconSrc,
  extraClass,
  size,
  iconExtraClass,
  playButtonIconWidth,
  playButtonIconHeight,
}) => (
  <IconButton
    onClick={() => setTogglePlayPause({ id })}
    color="transparent"
    size={size}
    extraClass={extraClass}
    iconExtraClass={iconExtraClass}
    iconSrc={getPlayPauseIcon({ playing, pauseIconSrc, playIconSrc })}
    title={title}
    iconWidth={playButtonIconWidth}
    iconHeight={playButtonIconHeight}
  />
);

PlayPauseControl.propTypes = {
  id: PropTypes.string.isRequired,
  playing: PropTypes.bool,
  title: PropTypes.string,
  setTogglePlayPause: PropTypes.func,
  playIconSrc: PropTypes.string,
  pauseIconSrc: PropTypes.string,
  extraClass: PropTypes.string,
  iconExtraClass: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  playButtonIconWidth: PropTypes.number,
  playButtonIconHeight: PropTypes.number,
};

export default PlayPauseControl;
